import { FetchAPI } from '../Main/fetchAPI';
import { BEHAVIORS, CLIENT, TARGETS, TARGETS_ANNOTATIONS, TARGETS_GLOBAL_ANNOTATIONS } from '../constants';
import {
	BehaviorAnnotationProperties,
	GlobalAnnotationProperties,
	TargetAnnotationProperties,
} from './graphAnnotationProperties';
import {
	DeleteAnnotationProperties,
	DeleteBehaviorAnnotationProperties,
} from '../../State/clientSlice/graphAnnotationSlice';

export const GraphAnnotation = {
	global: {
		addGlobalAnnotation: (data: GlobalAnnotationProperties) =>
			FetchAPI.postJson({
				urlStr: `${CLIENT}/clients/${data.clientId}/annotations/global`,
				data,
			}),
	},
	targets: {
		getAnnotations: (targetId: string) =>
			FetchAPI.getJson({
				urlStr: `${TARGETS}/${targetId}/annotations`,
			}),
		addAnnotation: (data: TargetAnnotationProperties) =>
			FetchAPI.postJson({
				urlStr: `${TARGETS_ANNOTATIONS}`,
				data,
			}),
		addGlobalAnnotation: (data: TargetAnnotationProperties) =>
			FetchAPI.postJson({
				urlStr: `${TARGETS_GLOBAL_ANNOTATIONS}`,
				data,
			}),
		getAnnotation: (id: string) =>
			FetchAPI.getJson({
				urlStr: `${TARGETS_ANNOTATIONS}/${id}`,
			}),
		updateAnnotation: (id: string) =>
			FetchAPI.putJson({
				urlStr: `${TARGETS_ANNOTATIONS}/${id}`,
			}),
		deleteAnnotation: ({ annotationId, targetId }: DeleteAnnotationProperties) =>
			FetchAPI.deleteJson({
				urlStr: targetId
					? `${TARGETS_ANNOTATIONS}/${annotationId}?targetId=${targetId}`
					: `${TARGETS_ANNOTATIONS}/${annotationId}`,
			}),
	},

	behaviors: {
		getAnnotations: (behaviorId: string) =>
			FetchAPI.getJson({
				urlStr: `${BEHAVIORS}/${behaviorId}/annotations`,
			}),
		addBehaviorAnnotation: (data: BehaviorAnnotationProperties) =>
			FetchAPI.postJson({
				urlStr: `${CLIENT}/behavior/annotations`,
				data,
			}),
		getBehaviorAnnotation: (id: string) =>
			FetchAPI.getJson({
				urlStr: `${BEHAVIORS}/annotations/${id}`,
			}),
		updateBehaviorAnnotation: (id: string) =>
			FetchAPI.putJson({
				urlStr: `${BEHAVIORS}/annotations/${id}`,
			}),
		deleteBehaviorAnnotation: ({ annotationId, behaviorId }: DeleteBehaviorAnnotationProperties) =>
			FetchAPI.deleteJson({
				urlStr: behaviorId
					? `${BEHAVIORS}/annotations/${annotationId}?behaviorId=${behaviorId}`
					: `${BEHAVIORS}/annotations/${annotationId}`,
			}),
	},
};
